<template>
  <div class="view-header">
    <div class="title">
      <slot>Title</slot>
    </div>
    <div class="items">
      <slot name="items"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewHeader",
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/app-variables";
.view-header {
  display: flex;
  padding: 0 20px;
  height: 56px;
  align-items: center;
  border-bottom: 1px solid $--app-sidebar-border-color;
  justify-content: space-between;
  & > .title {
    color: $--app-main-color;
  }
}
</style>
